/* eslint-disable react/prop-types */
import React from "react";
import Grid from "@material-ui/core/Grid";

import { topBarStyles } from "../../courseStyles";
import Search from "./Search";
import Button from "./Button";

export default function TopBar({
  value,
  searchQuery,
  setSearchQuery,
  onCreateClick,
}) {
  const classes = topBarStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid item xs={6} xl={6} md={6} lg={6} className={classes.dFlex1} />
        <Grid item xs={6} className={classes.dFlex}>
          <Grid item className={classes.positionRelative}>
            {value === 0 && (
              <Search
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                text="Search Course..."
              />
            )}
            {value === 2 && (
              <Search
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                text="Search User..."
              />
            )}
          </Grid>
          {value === 0 && (
            <Grid item>
              <Button title="Create Course" onCreateClick={onCreateClick} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
